import axios from 'axios'

const brokerage_company_form = {
  namespaced: true,

  state() {
    return {
      data: {
        name: null,
        name_kana: null,
        licence_type: null,
        licence_number: null,
        postal_code: null,
        prefecture_code: null,
        address1: null,
        address2: null,
        tel: null,
        fax: null,
      },
      errors: {},
    };
  },

  getters: {
    parameters(state) {
      return {
        name: state.data.name,
        name_kana: state.data.name_kana,
        licence_type: state.data.licence_type,
        licence_number: state.data.licence_number,
        postal_code: state.data.postal_code,
        prefecture_code: state.data.prefecture_code,
        address1: state.data.address1,
        address2: state.data.address2,
        tel: state.data.tel,
        fax: state.data.fax,
      }
    }
  },

  mutations: {
    setData(state, data) {
      state.data.name = data.name;
      state.data.name_kana = data.name_kana;
      state.data.licence_type = parseInt(data.licence_type);
      state.data.licence_number = data.licence_number;
      state.data.postal_code = data.postal_code;
      state.data.prefecture_code = parseInt(data.prefecture_code);
      state.data.address1 = data.address1;
      state.data.address2 = data.address2;
      state.data.tel = data.tel;
      state.data.fax = data.fax;
      state.errors = {};
    },

    resetData(state) {
      state.data.name = null;
      state.data.name_kana = null;
      state.data.licence_type = null;
      state.data.licence_number = null;
      state.data.postal_code = null;
      state.data.prefecture_code = null;
      state.data.address1 = null;
      state.data.address2 = null;
      state.data.tel = null;
      state.data.fax = null;
      state.errors = {};
    },

    setErrors(state, errors) {
      state.errors = {...errors};
    },

    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },

  actions: {
    load({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/brokerage_companies/me').then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    },

    update({getters, commit}) {
      return new Promise((resolve, reject) => {
        axios.put('/api/brokerage_companies/me', getters.parameters).then((response) => {
          commit('setData', response.data.data);
          return axios.get('/api/brokers/me').then((response) => {
            commit('account/setData', response.data.data, {root: true});
            commit('setFlashMessage', {value: '更新しました'}, {root: true});
            resolve(true);
          });
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({handled});
        });
      });
    }
  }
};

export default brokerage_company_form;
